import * as Sentry from '@sentry/react';
import {PropsWithChildren} from 'react';
import {CreateSheet, css} from 'aphrodite';
import {Accent2, PageBg, Secondary, TextColor} from 'src/themes/colors';

function ErrorFallback() {
    return (
        <div className={css(Styles.page)}>
            <div className={css(Styles.content)}>
                <h1 className={css(Styles.heading)}>
                    Ooops!
                    <br />
                    Something Went Wrong
                </h1>
                <p className={css(Styles.text)}>
                    Please check back later or contact us at{' '}
                    <a
                        href="mailto:hello@motoragazzi.com"
                        className={css(Styles.emailLink)}
                    >
                        hello@motoragazzi.com
                    </a>{' '}
                    if the issue persists.
                </p>
            </div>
        </div>
    );
}

export default function ErrorBoundary({children}: PropsWithChildren) {
    return (
        <Sentry.ErrorBoundary
            fallback={<ErrorFallback />}
            beforeCapture={scope => {
                scope.setTag('error_boundary', 'app-root');
            }}
        >
            {children}
        </Sentry.ErrorBoundary>
    );
}

const Styles = CreateSheet({
    page: {
        alignItems: 'center',
        backgroundColor: PageBg,
        display: 'flex',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '40px 24px',
        textAlign: 'center',
    },
    content: {
        maxWidth: 720,
    },
    heading: {
        color: TextColor,
        fontFamily: 'Nunito Sans',
        fontSize: 40,
        fontStyle: 'normal',
        fontWeight: 800,
        lineHeight: 1.2,
        margin: 0,
        marginBottom: 24,
        '@media(max-width: 650px)': {
            fontSize: 30,
        },
    },
    text: {
        color: Secondary,
        fontFamily: 'Nunito Sans',
        fontSize: 20,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 1.5,
        margin: 0,
        '@media(max-width: 650px)': {
            fontSize: 18,
        },
    },
    emailLink: {
        color: Accent2,
        fontWeight: 700,
        textDecoration: 'underline',
    },
});
